import { connect } from "react-redux";
import {
  editEventModalUpdate,
  editModalConfirm,
  editModalSplitConfirm,
  editModalSelector,
  toggleEditCrew,
  toggleEditModal,
} from "../../../redux/modals";
import EditEventModal from "./EditEventModal";

const mapStateToProps = editModalSelector;

const mapDispatchToProps = {
  onChange: editEventModalUpdate,
  onSplitConfirm: editModalSplitConfirm,
  onConfirm: editModalConfirm,
  onHide: () => toggleEditModal(),
  onToggleEditCrew: toggleEditCrew,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditEventModal);
